<template>
  <div class="furnish-main">
    <el-tabs v-model="card_index">
      <el-tab-pane label="PDA巡检" name="PdaInspection">
        <PdaInspection v-if="card_index==='PdaInspection'" />
      </el-tab-pane>
      <el-tab-pane label="消防管理" name="FireManagement">
        <FireManagement v-if="card_index==='FireManagement'" />
      </el-tab-pane>
      <el-tab-pane label="违规管理" name="ViolationManagement">
        <ViolationManagement v-if="card_index==='ViolationManagement'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PdaInspection from "./components/pda_check/PdaInspection";
import ViolationManagement from "./components/pda_check/ViolationManagement";
import FireManagement from "./components/pda_check/FireManagement";
export default {
  name: "PreparationEntry",
  components: {ViolationManagement, PdaInspection, FireManagement},
  data(){
    return{
      card_index:"PdaInspection"
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(../../common.scss);
.furnish-main{
  height: calc(100vh - 230px);
  overflow-y: scroll;
  .el-link-common{
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/DecorationInspection.vue